import React, { useEffect, useState } from 'react'
import { withRouter } from "../../../util/with-router";
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { PROJECT_MANAGEMENT } from '../../../constants/route-paths'
import { getPurchaseOrder } from '../../../actions/project-management.action'
import idx from 'idx'
import { useNavigate, useParams } from 'react-router';
import { useSearchParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import { resolveProjectType } from '../utils/resolve-project-type';
import Table from 'react-bootstrap/Table';
import { Button } from 'react-bootstrap';
import { TaskType } from 'src/util/enums';
import WorkOrderInvoicesSection from "../../../components/work-order-invoices-section";
import { toUSD } from 'src/util/currency-formatter';
import Popover from 'react-bootstrap/Popover';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import DownloadDialog from "../../../components/download-dialog";
import DeleteDialog from "../../../components/delete-dialog";
import Modal from "../../../components/modal/modal";
import PayInvoice from "../../vendor-payment/pay-invoice";
import {
  deletePurchaseOrder,
  downloadProjectPO,
  cancelWorkOrder,
  reactivateWorkOrder
} from '../../../actions/project-management.action';
import { getGlobalSettingTemplateTypes } from '../../../actions/global-setting-template.action';
import {
  VENDOR_PAYMENT,
  CONTRACTORS,
  EDIT_WORK_ORDER
} from "../../../constants/route-paths";
import { getProjectCustomer } from '../../../actions/invoice.action';
import { addProjectAction } from '../../../slice/project-summary';

function ViewWO(props) {
  const { wContractorPermission, userAccessControl } = props;
  const writePermission = userAccessControl === 2 ? true : false;

  const [poData, setPoData] = useState({});
  const [materialItems, setMaterialItems] = useState([]);
  const [description, setDescription] = useState();
  const [quotationId, setQuotationId] = useState([]);
  const [quoteNo, setQuoteNo] = useState('');
  const [vendorName, setVendorName] = useState([]);
  const [attachments, setAttachments] = useState([]);
  const laborColumns = ['Tasks/Section', 'Description', 'Quote Submitted'];

  const [showPayInvoice, setShowInvoice] = useState(false);
  const [invoiceReloadKey, setInvoiceReloadKey] = useState(0);
  const [templateOptions, setTemplateOptions] = useState([]);
  const [downloadData, setDownloadData] = useState({ open: false, id: "" });
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [openCancelDialog, setOpenCancelDialog] = useState(false);
  const [openReactivateDialog, setOpenReactivateDialog] = useState(false);

  const { projectId, woId } = useParams();
  let [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { projectDetail = {}, projectSummary = {}, project: projectState } = useSelector(state => state);
  const [projectName, setProjectName] = useState("");

  let projectType = searchParams.get("project-type")
    || idx(projectDetail, _ => _.project.projectDataType)
    || idx(projectDetail, _ => _.project.res.projectType)
    || idx(projectSummary, _ => _.project.projectDataType)
    || idx(projectSummary, _ => _.project.res.projectType);

  projectType = resolveProjectType(projectType, projectState);

  useEffect(() => {
    const currentName =
      idx(projectSummary, _ => _.project.projectName) ||
      idx(projectDetail, _ => _.project.projectName);
    if (currentName) {
      setProjectName(currentName);
      return;
    }
    if (projectId) {
      dispatch(getProjectCustomer(projectId)).then((res) => {
        if (res) {
          setProjectName(res.name);
          dispatch(addProjectAction({
            projectId: res.id,
            projectName: res.name,
            projectDataType: res.projectType,
            projectType: res.type
          }));
        }
      }).catch(e => console.error(e));
    }
  }, [projectId, projectSummary, projectDetail, dispatch]);

  useEffect(() => {
    getPurchaseOrder(woId)
  }, [woId])

  const getPurchaseOrder = async (id) => {
    const query = `?woId=${id}`
    const response = await props.getPurchaseOrder(query)
    const { rfq, items, vendor, quotation, quoteNo } = response
    setDescription(idx(rfq, _ => _.description))
    setMaterialItems(idx(items, _ => _) || [])
    setPoData(response)
    setQuotationId(idx(quotation, _ => _.id))
    setQuoteNo(quoteNo)
    setVendorName(idx(vendor, _ => _.business_name))
    const attachmentList = Array.isArray(idx(response, _ => _.attachment)) ? idx(response, _ => _.attachment) : []
    const attachment = attachmentList.map((item, idxKey) => {
      return (
        <div key={idxKey} className="attachedFiles">
          <p style={{ margin: '0 10px 0 0' }}>{item.name}</p>
        </div>
      )
    })
    setAttachments(attachment)
  }

  const viewProjectList = () => navigate(`/projects?project-type=${projectType}`)
  const viewProject = () => {
    const actualProjectId = projectId || poData.projectId;
    if (actualProjectId) {
      navigate(`/${PROJECT_MANAGEMENT}/view/${actualProjectId}`);
    }
  };
  const viewWoList = () => {
    const actualProjectId = projectId || poData.projectId;
    if (actualProjectId) {
      navigate(`/${PROJECT_MANAGEMENT}/work-order/${actualProjectId}`);
    }
  };

  const gettemplate = async (type) => {
    try {
      let newdata = [];
      const templateData = await dispatch(getGlobalSettingTemplateTypes(type, null));
      if (Array.isArray(templateData)) {
        templateData.forEach((item) => {
          newdata.push({
            value: item.id,
            key: item.name,
          });
        });
      }
      setTemplateOptions(newdata);
    } catch (e) {
      console.error('Failed to fetch templates:', e);
    }
  };

  const handleDownloadDialog = (id = "", templateType = "work_order") => {
    const actualId = id || woId;
    setDownloadData(prev => {
      const isOpening = !prev.open;
      const newDownloadData = { ...prev, open: isOpening, id: actualId || "" };
      if (isOpening) {
        gettemplate(templateType);
      }
      return newDownloadData;
    });
  };

  const downloadFile = async (fileFormat = "pdf", tempId) => {
    try {
      await dispatch(downloadProjectPO(downloadData.id, fileFormat, tempId));
      handleDownloadDialog();
    } catch (e) {
      console.error('Download failed:', e);
    }
  };

  const deleteDialogState = () => {
    setOpenDeleteDialog(prev => !prev);
  };

  const deleteHandler = async () => {
    deleteDialogState();
    if (woId) {
      await dispatch(deletePurchaseOrder(woId, "Work Order Deleted successfully"));
      viewWoList();
    }
  };

  const cancelDialogState = () => {
    setOpenCancelDialog(prev => !prev);
  };

  const confirmCancelWO = async () => {
    if (woId) {
      const res = await dispatch(cancelWorkOrder(woId));
      if (res?.status === 'SUCCESS') {
        cancelDialogState();
        getPurchaseOrder(woId);
      }
    }
  };

  const reactivateDialogState = () => {
    setOpenReactivateDialog(prev => !prev);
  };

  const confirmReactivateWO = async () => {
    if (woId) {
      const res = await dispatch(reactivateWorkOrder(woId));
      if (res?.status === 'SUCCESS') {
        reactivateDialogState();
        getPurchaseOrder(woId);
      }
    }
  };

  const editWO = () => {
    navigate(`/${CONTRACTORS}/${EDIT_WORK_ORDER.replace(':poId', woId).replace(':workType', 'project')}`, {
      state: {
        from: 'project-wo-list',
        projectId: projectId || poData.projectId,
        projectName: idx(projectDetail, _ => _.project.projectName),
        projectType: idx(projectDetail, _ => _.project.projectDataType)
      }
    });
  };

  const handlePayInvoiceModal = (state) => {
    setShowInvoice(prev => !prev);
    if (showPayInvoice && state) {
      getPurchaseOrder(woId);
      setInvoiceReloadKey(prev => prev + 1);
    }
  };

  const viewInvoices = () => navigate(`/${VENDOR_PAYMENT}?project=${projectId || poData.projectId}&woId=${woId}`);

  const renderMenu = (
    <Popover id="popover-basic" data-cy="wo-details-action-menu" style={{ border: '1px solid #ccc' }}>
      <Popover.Body>
        <ul className="action-block-list mb-0">
          <li onClick={() => handleDownloadDialog(woId, "work_order")} data-cy="download-wo">Download WO</li>
          {wContractorPermission && <li onClick={() => handlePayInvoiceModal(true)} data-cy="receive-invoice">
            Receive Invoice
          </li>}
          <li onClick={viewInvoices}>View Invoices</li>
          {writePermission && (poData.status === "Approved" || poData.status === "Active" || poData.status === "Pending") && (
            poData.invoicestatus === "Not Invoiced" ? (
              <li onClick={cancelDialogState} data-cy="cancel-wo">Cancel</li>
            ) : (poData.invoicestatus === "Partially Invoiced" || poData.invoicestatus === "Fully Invoiced") ? (
              <li className="disabled" data-cy="cancel-wo-disabled">
                <span title="Cannot cancel a partially or fully invoiced Work Order">Cancel</span>
              </li>
            ) : <li onClick={cancelDialogState} data-cy="cancel-wo">Cancel</li>
          )}
          {writePermission && (poData.status !== "Finished" && poData.status !== "Completed") && (
            <li onClick={editWO} data-cy="edit-wo">Edit WO</li>
          )}
          {writePermission && (poData.status === "Pending" || (poData.status === "Approved" && poData.invoicestatus === "Not Invoiced")) && (
            <li onClick={deleteDialogState} data-cy="delete-wo">Delete</li>
          )}
          {writePermission && (poData.status === "Cancelled") && (
            <li onClick={() => reactivateDialogState()} data-cy="reactivate-wo">Reactivate</li>
          )}
        </ul>
      </Popover.Body>
    </Popover>
  );

  return (
    <div className="purchase-order-block">
      {showPayInvoice && (
        <PayInvoice
          projectId={projectId || poData.projectId}
          vendorId={idx(poData, _ => _.vendor.id)}
          poId={woId}
          poNo={poData.f_id || poData.id}
          projectName={idx(projectDetail, _ => _.project.projectName)}
          vendorName={vendorName}
          isSubContractor={true}
          workType="project"
          handleDownloadDialog={handleDownloadDialog}
          handleClose={handlePayInvoiceModal}
          getWOList={() => getPurchaseOrder(woId)}
          dataCy="receive-invoice-wo-modal"
        />
      )}

      <div className="d-flex align-items-center justify-content-between">
        <h2 className="content-heading text-uppercase mb-0">View Work Order</h2>
        <div className="action-dropdown me-4">
          <OverlayTrigger trigger="click" rootClose placement="bottom" overlay={renderMenu}>
            <Button variant="default" data-cy="action-menu-button">
              <MoreHorizIcon />
            </Button>
          </OverlayTrigger>
        </div>
      </div>

      <div className="col-12 breadcrumb-block p-0">
        <Breadcrumb>
          <Breadcrumb.Item onClick={viewProjectList}>PROJECTS</Breadcrumb.Item>
          <Breadcrumb.Item onClick={viewProject}>{projectName || idx(projectDetail, _ => _.project.projectName) || idx(projectSummary, _ => _.project.projectName) || poData.projectName}</Breadcrumb.Item>
          <Breadcrumb.Item onClick={viewWoList} >Work Order LIST </Breadcrumb.Item>
          <Breadcrumb.Item active>Work Order</Breadcrumb.Item>
        </Breadcrumb>
      </div>

      <div className="row">
        {description && <div className="col-lg-4 mt-3">
          <div className="view-block">
            <label>Description</label>
            <p>{description}</p>
          </div>
        </div>}
        <div className="col-lg-4 mt-3">
          <div className="view-block">
            <label>Vendor Type</label>
            <p>Contractor</p>
          </div>
        </div>
        <div className="col-lg-4 mt-3">
          <div className="view-block">
            <label>Work Order No</label>
            <p>{idx(poData, _ => _.f_id) || idx(poData, _ => _.id)}</p>
          </div>
        </div>
        {quotationId && <div className="col-lg-4 mt-3">
          <div className="view-block">
            <label>Quote Request No</label>
            <p>{quotationId}</p>
          </div>
        </div>}
        {quoteNo && <div className="col-lg-4 mt-3">
          <div className="view-block">
            <label>Quote No</label>
            <p>{quoteNo}</p>
          </div>
        </div>}
        <div className="col-lg-4 mt-3">
          <div className="view-block">
            <label>Vendor</label>
            <p>{vendorName}</p>
          </div>
        </div>
        <div className="col-lg-4 mt-3">
          <div className="view-block">
            <label>Attachments</label>
            <p>{attachments}</p>
          </div>
        </div>
        <div className="col-lg-12 mt-3">
          <div className="view-block">
            <label>Notes</label>
            <p>{idx(poData, _ => _.notes) || '-'}</p>
          </div>
        </div>
        <div className="col-12">
          <div className="material-list-block mt-4">
            <div className="table-responsive">
              <Table bordered className="table-create table-material table-material-ch">
                <thead>
                  <tr>
                    {laborColumns.map((column, i) => (
                      <th key={i}>{column}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {materialItems.map((item, index) => (
                    <tr key={index}>
                      <td>{item.stagePath?.includes('>') ? `${item.stagePath.split(' > ')[0]} > ${item.taskName}` : item.taskType === TaskType.TASK ? `${item.stagePath} > ${item.taskName}` : item.taskName}</td>
                      <td>{item.name}</td>
                      <td>{toUSD(item.total)}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </div>
        </div>
      </div>

      <WorkOrderInvoicesSection
        poUuid={woId}
        projectId={projectId || poData.projectId}
        vendorType="sub-contractor"
        reloadTrigger={invoiceReloadKey}
        onDeleted={() => getPurchaseOrder(woId)}
        onNavigate={(invoiceId) => navigate(`/vendor-payment/view/${invoiceId}?id=${projectId || poData.projectId}&poId=${woId}&type=project`)}
      />

      <div className="col-12 d-flex mt-3 justify-content-end">
        <Button type="submit" onClick={viewWoList} className="secondarybtn cancelbtn">BACK</Button>
      </div>

      <DeleteDialog
        open={openDeleteDialog}
        id={woId}
        deleteHandler={deleteHandler}
        dialogClose={deleteDialogState}
        moduleName="Work Order"
        description={`Work Order - ${poData.id}`}
        dataCy="delete-wo-dialog"
      />

      <Modal
        open={openCancelDialog}
        onClose={cancelDialogState}
        fullWidth={true}
        maxWidth='sm'
        modalHeading="Cancel Work Order"
        modalSaveTxt={<span data-cy="confirm-cancel">Yes</span>}
        modalCloseTxt='No'
        onClick={confirmCancelWO}
        showActionBtn
        savebtnClass='createBtn'
        cxlbtnClass='cancelBtn'
        primary
        dataCy="cancel-wo-dialog"
      >
        <p>Are you sure you want to cancel Work Order - {poData.f_id || poData.id}? </p>
      </Modal>

      <Modal
        open={openReactivateDialog}
        onClose={reactivateDialogState}
        fullWidth={true}
        maxWidth='sm'
        modalHeading="Reactivate Work Order"
        modalSaveTxt={<span data-cy="confirm-reactivate">Yes</span>}
        modalCloseTxt='No'
        onClick={confirmReactivateWO}
        showActionBtn
        savebtnClass='createBtn'
        cxlbtnClass='cancelBtn'
        primary
        dataCy="reactivate-wo-dialog"
      >
        <p>Are you sure you want to reactivate Work Order - {poData.f_id || poData.id}? </p>
      </Modal>

      <DownloadDialog
        open={downloadData.open}
        id={downloadData.id}
        downloadFile={downloadFile}
        templateOptions={templateOptions}
        handleDownloadDialog={handleDownloadDialog}
        downloadModuleName="WorkOrder List"
        dataCy="download-wo-dialog"
      />
    </div>
  )
}

const mapStateToProps = state => ({
});

const mapDispatchToProps = dispatch => ({
  getPurchaseOrder: bindActionCreators(getPurchaseOrder, dispatch)
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ViewWO))
